import React, { useEffect, useRef, useState } from 'react';
import './Location.css';
import './Home.css';
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import projects from '../data/ProjectsData';
import DiscussForm from '../components/DiscussForm';

function LandownerShare() {
  const [theme, setTheme] = useState('light');
  const accordionRefs = useRef({});

  useEffect(() => {
    window.scrollTo(0, 0);
    const currentTheme = localStorage.getItem('theme') || 'light';
    setTheme(currentTheme);
  }, []);

  // Filter only projects that have a sub-category
  const landownerProjects = projects.filter((project) => project["sub-category"]);

  // Group projects by sub-category (using bracket notation for key access)
  const grouped = {
    "Builder/Landlord": landownerProjects.filter(
      (p) => p["sub-category"]?.toLowerCase() === "builder/landlord"
    ),
    "Landlord": landownerProjects.filter(
      (p) => p["sub-category"]?.toLowerCase() === "landlord"
    ),
    "Landlord/Builder": landownerProjects.filter(
      (p) => p["sub-category"]?.toLowerCase() === "landlord/builder"
    ),
    "Landlord/Resale": landownerProjects.filter(
      (p) => p["sub-category"]?.toLowerCase() === "landlord/resale"
    ),
  };

  useEffect(() => {
    const observerOptions = { threshold: 0, root: null };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute('data-id');
        const collapseElement = document.getElementById(`collapse-${id}`);
        if (!entry.isIntersecting && collapseElement?.classList.contains('show')) {
          collapseElement.classList.remove('show');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    Object.entries(accordionRefs.current).forEach(([key, el]) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className='location-main'>
      {/* Hero Section */}
      <div className='about-hero hyd-hero'>
        <div className='about-hero-inner d-flex justify-content-center align-items-center'>
          <div>
            <h1 className='syne-title'>LANDOWNER SHARE<span className='text-rose'>.</span></h1>
            <p className='text-center'>
              <Link to="/" className="text-dark text-decoration-none">Home</Link> /{' '}
              <span className='text-rose'>Landowner Share</span>
            </p>
          </div>
        </div>
      </div>

      {/* Accordion Section */}
      <div className='container py-5'>
        <div className="accordion" id="accordionProjects">
          {Object.entries(grouped).map(([subCategory, items]) => (
            <div className="accordion-item" key={subCategory}>
              <h2 className="accordion-header" id={`heading-${subCategory}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${subCategory}`}
                  aria-expanded="false"
                  aria-controls={`collapse-${subCategory}`}
                >
                  <h1 className="syne-title mb-0 w-100">
                    {subCategory}
                    <span className="text-rose">.</span>
                  </h1>
                </button>
              </h2>
              <div
                ref={(el) => (accordionRefs.current[subCategory] = el)}
                data-id={subCategory}
                id={`collapse-${subCategory}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading-${subCategory}`}
                data-bs-parent="#accordionProjects"
              >
                <div className="accordion-body">
                  <div className="row">
                    {items.length > 0 ? (
                      items.map((project) => (
                        <div className="col-lg-4 col-md-6 my-3" key={project.id}>
                          <Link to={`/projects/${project.id}`} className="text-decoration-none text-dark">
                            <div className="home-land-card h-100 shadow-sm">
                              <img
                                src={project.image}
                                className="img-fluid home-land-card-img"
                                alt={project.title}
                              />
                              <div
                                className={`home-land-card-content p-3 text-center ${theme === 'dark' ? 'bg-dark text-light' : 'bg-white'
                                  }`}
                              >
                                <h6 className="fw-bold">{project.title}</h6>
                                <p className="mb-1">{project.location}</p>
                                <div className="home-about-btn text-center">
                                  <span className="text-rose">
                                    <FaLongArrowAltRight /> Know More
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-muted py-5 w-100">
                        <h5>Projects are adding soon.</h5>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Discuss Form */}
      <DiscussForm />
    </div>
  );
}

export default LandownerShare;
